var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c("div", { staticClass: "finish-tour-modal" }, [
        _c("div", { staticClass: "modal-overlay" }),
        _vm._v(" "),
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h2", [_vm._v(_vm._s(_vm.currentItem.title))]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "close-button", on: { click: _vm.closeModal } },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("line", {
                      attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                    }),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "video-container" }, [
              _vm.isLoading
                ? _c("div", { staticClass: "loading-spinner-overlay" }, [
                    _c("div", { staticClass: "spinner" }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("iframe", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isLoading,
                    expression: "!isLoading",
                  },
                ],
                attrs: {
                  src: _vm.currentItem.videoUrl
                    ? _vm.currentItem.videoUrl +
                      "?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3"
                    : _vm.currentItem.docsUrl,
                  frameborder: "0",
                  allow:
                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                  allowfullscreen: "",
                },
                on: {
                  load: function ($event) {
                    _vm.isLoading = false
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "action-buttons" },
              [
                _c("div", { staticClass: "resource-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn docs-btn",
                      on: { click: _vm.gotoDocumentation },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "btn-icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("setupWizard.finishModalDoc")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn support-btn",
                      on: { click: _vm.openSupport },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "btn-icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("setupWizard.finsihModalLiveSupport")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn videos-btn",
                      on: { click: _vm.openVideos },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "btn-icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("polygon", {
                            attrs: { points: "23 7 16 12 23 17 23 7" },
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              x: "1",
                              y: "5",
                              width: "15",
                              height: "14",
                              rx: "2",
                              ry: "2",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("setupWizard.finishModalVideos")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a-tooltip",
                  {
                    attrs: {
                      placement: "left",
                      overlayStyle: { zIndex: "99999 !important" },
                      title: _vm.$t("setupWizard.completedWarning"),
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn close-btn",
                        on: { click: _vm.completeTutorial },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("setupWizard.completed")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }